import { TransactionDestinationType, TransactionSourceType } from "../../../state/types"
import { Data, ModalId, showToast, useUIActions } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { useNavigate } from "react-router-dom"
import { useCashFundActions } from "../../../actions/cashFundActions"
import { Emitter, Event } from "../../../../../features/event-emitter"

export const useActions = () => {
    const navigate = useNavigate()

    const { transferMoney } = useCashFundActions()
    const { closeModal } = useUIActions()

    const submitTransfer = async (
        transferData: Data,
        concept: string
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const sourceId = define(transferData.sourceId) as string
        const amount = define(transferData.amount) as number
        const destinationId = define(transferData.destinationId) as string        
        await transferMoney(TransactionSourceType.CASH_FUND, TransactionDestinationType.CASH_FUND, amount, sourceId, destinationId, new Date(), false, concept)
        
        closeModal(ModalId.SPINNER)
        showToast('La transferencia fue completada.')
        navigate(-1)
    }
    
    return {
        submitTransfer
    }
}
